import { TFormalOffer } from './formalOffers.types';
import { getIsRCFOffer } from './getIsRCFOffer';

export const getHasRCFOffer = (formalOffers: TFormalOffer[]) => {
    return Boolean(formalOffers.find((offer) => getIsRCFOffer(offer)));
};
